<template>
    <licitacao-esclarecimento-impugnacao-vazio v-if="naoPossuiEsclarecimentoImpugnacao"/>
    <div class="az-form-content" v-else>
        <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex xs12 sm12 d-flex>
                    <span class="az-subtitle primary--text">Esclarecimentos</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                    <v-data-table v-if="esclarecimentos.length > 0"
                                  :headers="colunasTabela"
                                  :items="esclarecimentos"
                                  :loading="false"
                                  hide-actions
                                  class="az-table-list table-dados-esclarecimentos-impugnacoes"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>
                                    <span>{{ props.item.dataCadastro | azDate('DD/MM/YYYY HH:mm') }}</span>
                                </td>
                                <td>
                                    <span v-if="props.item && props.item.fornecedor && props.item.fornecedor.razaoSocial">
                                      {{ props.item.fornecedor.razaoSocial }}
                                    </span>
                                    <span v-else-if="props.item.nomeRazaoSocial">
                                      {{ props.item.nomeRazaoSocial }}
                                    </span>
                                    <span v-else>
                                      --
                                    </span>
                                </td>
                                <td class="d-inline-block text-truncate max-25" >{{ props.item.assunto }}</td>
                                <td>
                                    <span>{{ possuiAnexo(props.item) }}</span>
                                </td>
                                <td :class="{'status-rascunho' : props.item.situacao === 'RASCUNHO'}">{{ retornaSituacao(props.item.situacao) }}</td>
                                <td class="table-actions">
                                    <div v-if="props.item.situacao != 'RASCUNHO'">
                                        <a @click="abrirModalVisualizacao(props.item)" title="Visualizar">
                                            <v-icon>search</v-icon>
                                        </a>
                                    </div>
                                    <div v-else>
                                        <a @click="abrirModalSolicitacaoEdicao(props.item)" title="Visualizar">
                                            <v-icon>edit</v-icon>
                                        </a>
                                    </div>
                                    <div>
                                      <a v-if="props.item.relatorioUri" :href="criarLinkDownload(props.item.relatorioUri)" target="_blank"
                                         title="Download Relatório" class="az-action-link-icon">
                                        <v-icon>get_app</v-icon>
                                      </a>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-if="!esclarecimentos.length">
                    <az-ops title="Nenhum esclarecimento encontrado."
                            message="Este processo não possui nenhum esclarecimento até o momento."
                    ></az-ops>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                    <span class="az-subtitle primary--text">Impugnações</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                    <v-data-table v-if="impugnacoes.length > 0"
                                  :headers="colunasTabela"
                                  :items="impugnacoes"
                                  :loading="false"
                                  hide-actions
                                  class="az-table-list table-dados-esclarecimentos-impugnacoes"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                              <td>
                                <span>{{ props.item.dataCadastro | azDate('DD/MM/YYYY HH:mm') }}</span>
                              </td>
                              <td>
                                <span v-if="props.item && props.item.fornecedor && props.item.fornecedor.razaoSocial">
                                      {{ props.item.fornecedor.razaoSocial }}
                                </span>
                                <span v-else-if="props.item.nomeRazaoSocial">
                                  {{ props.item.nomeRazaoSocial }}
                                </span>
                                <span v-else>
                                  --
                                </span>
                              </td>
                              <td class="d-inline-block text-truncate max-25" >{{ props.item.assunto }}</td>
                              <td>
                                <span>{{ possuiAnexo(props.item) }}</span>
                              </td>
                              <td :class="{'status-rascunho' : props.item.situacao === 'RASCUNHO'}">{{ retornaSituacao(props.item.situacao) }}</td>
                              <td class="table-actions">
                                <div>
                                  <div v-if="props.item.situacao != 'RASCUNHO'">
                                    <a @click="abrirModalVisualizacao(props.item)" title="Visualizar">
                                      <v-icon>search</v-icon>
                                    </a>
                                  </div>
                                  <div v-else>
                                    <a @click="abrirModalSolicitacaoEdicao(props.item)" title="Visualizar">
                                      <v-icon>edit</v-icon>
                                    </a>
                                  </div>
                                  <div>
                                    <a v-if="props.item.relatorioUri" :href="criarLinkDownload(props.item.relatorioUri)" target="_blank"
                                       title="Download Relatório" class="az-action-link-icon">
                                      <v-icon>get_app</v-icon>
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-flex xs12 sm12 d-flex v-if="!impugnacoes || !impugnacoes.length">
                        <az-ops title="Nenhuma impugnação encontrada."
                                message="Este processo não possui nenhuma impugnação até o momento."
                        ></az-ops>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
        <modal-visualizar-resposta-esclarecimento-impugnacao
              v-if="exibirModalDetalhe"
              v-model="exibirModalDetalhe"
              @fecharModalVisualizacao="exibirModalDetalhe = false"
              :item="selectedItem"
              />
        <solicitacao-esclarecimento-impugnacao :item="selectedItem.tipo"
                                               :solicitacao="selectedItem"
                                               v-if="exibirModalSolicitacaoEdicao"
                                               @fecharDetalhe="exibirModalSolicitacaoEdicao = false"
                                               @solicitacaoEditada="buscarEsclarecimentoImpugnacao(selectedItem.tipo)"
                                               @solicitacaoEnviada="buscarEsclarecimentoImpugnacao(selectedItem.tipo)"/>
        <az-dialog v-if="exibirModalLimiteEsclarecimentoImpugnacao"
                   :width=600 @ok="exibirModalLimiteEsclarecimentoImpugnacao = false">
          <div>
          <span>Caro senhor fornecedor, conforme a legislação é permitido solicitar {{tipoSelecionado | tipoAnexoFornecedor}}
            do edital em até três dias úteis anteriores à data fixada para abertura da sessão pública.</span>
          </div>
        </az-dialog>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import LicitacaoEsclarecimentoImpugnacaoVazio
      from '@/views/licitacao/detalhe/orgao/EsclarecimentoImpugnacao/LicitacaoEsclarecimentoImpugnacaoVazio'
    import ModalVisualizarRespostaEsclarecimentoImpugnacao
      from '../orgao/EsclarecimentoImpugnacao/Modal/ModalVisualizarRespostaEsclarecimentoImpugnacao'
    import SolicitacaoEsclarecimentoImpugnacao from '../fornecedor/modal/LicitacaoFornecedorEsclarecimentoSolicitacao'
    import moment from 'moment/moment'


    export default {
        name: 'EsclarecimentoImpugnacao',
        components: {
            ModalVisualizarRespostaEsclarecimentoImpugnacao,
            LicitacaoEsclarecimentoImpugnacaoVazio,
            SolicitacaoEsclarecimentoImpugnacao
        },
        inject: ['$validator'],
        data() {
            return {
                colunasTabela: [
                    {
                        text: 'Data',
                        align: 'left',
                        sortable: true,
                        width: '15%',
                        class: 'primary--text',
                        value: 'dataCadastro'

                    },
                    {
                        text: 'Empresa/Nome',
                        align: 'left',
                        sortable: false,
                        width: '20%',
                        class: 'primary--text'
                    },
                    {
                        text: 'Assunto Esclarecimento',
                        align: 'left',
                        sortable: false,
                        width: '25%',
                        class: 'primary--text'
                    },
                    {
                        text: 'Anexo',
                        sortable: false,
                        align: 'left',
                        width: '10%',
                        class: 'primary--text'
                    },
                    {
                        text: 'Situação',
                        sortable: true,
                        align: 'left',
                        width: '20%',
                        class: 'primary--text',
                        value: 'situacao'
                    },
                    {
                        text: 'Ações',
                        sortable: false,
                        align: 'center',
                        width: '10%',
                        class: 'primary--text'
                    }
                ],
                licitacaoId: undefined,
                repository: 'repo1:licitacao',
                exibirModalDetalhe: false,
                selectedItem: undefined,
                exibirModalSolicitacaoEdicao: false,
                exibirModalLimiteEsclarecimentoImpugnacao: false,
            }
        },
        computed: {
            impugnacoes() {
               return this.impugnacoesLicitacao
            },
            esclarecimentos(){
                return this.esclarecimentosLicitacao;
            },
            naoPossuiEsclarecimentoImpugnacao() {
                return this.esclarecimentosLicitacao.length === 0 && this.impugnacoesLicitacao.length === 0
            },
            ...mapState(['loki', 'licitacao', 'anexosLicitacao', 'esclarecimentosLicitacao', 'impugnacoesLicitacao'])
        },
        methods: {
            retornaSituacao(situacao){
                if(situacao === 'AGUARDANDO'){
                    return 'Aguardando Resposta'
                } else if (situacao === 'RASCUNHO') {
                    return 'Rascunho (não enviado)'
                } else {
                    return 'Respondido'
                }
            },
            possuiAnexo(item){
                if(item.arquivoUri){
                    return 'Sim'
                }else{
                    return 'Não'
                }
            },
            abrirModalVisualizacao(item){
                this.selectedItem = item
                this.exibirModalDetalhe = true
            },
            abrirModalSolicitacaoEdicao(item) {
                this.selectedItem = item
                if(this.validaDataLimiteEsclarecimentoImpugnacao()) {
                    this.exibirModalLimiteEsclarecimentoImpugnacao = true
                } else {
                    this.exibirModalSolicitacaoEdicao = true
                }
            },
            async buscarEsclarecimentosLicitacao() {
                this.setMensagemLoading('Atualizando listagem de esclarecimentos...')
                await this.buscarEsclarecimentos(this.$route.params.id)
            },
            async buscarImpugnacoesLicitacao() {
                this.setMensagemLoading('Atualizando listagem de impugnações...')
                await this.buscarImpugnacoes(this.$route.params.id)
            },
            buscarEsclarecimentoImpugnacao(tipo) {
                if(tipo === 'IMPUGNACAO') {
                  this.buscarImpugnacoesLicitacao()
                }
                if(tipo === 'ESCLARECIMENTO') {
                  this.buscarEsclarecimentosLicitacao()
                }
                this.exibirModalSolicitacaoEdicao = false
            },
            validaDataLimiteEsclarecimentoImpugnacao(){
                return moment().isAfter(this.licitacao.dataLimiteEsclarecimentoImpugnacao)
            },
            ...mapActions([actionTypes.BUSCAR_ESCLARECIMENTOS, actionTypes.BUSCAR_IMPUGNACOES])
        }
    }
</script>

<style scoped lang="stylus">
    .table-dados-esclarecimentos-impugnacoes
        td
            color #777
        padding-bottom: 50px

    .table-status
        &__error i
            font-size: 18px
            color: #d79641

.status-rascunho
    color #F54927 !important

    @media (max-width: 720px)
        .table-dados-esclarecimentos-impugnacoes

            td:nth-of-type(1):before
                display none

            td:nth-of-type(2):before
                content: "Tipo:"

            td:nth-of-type(3):before
                content: "Data:"

            td:nth-of-type(4):before
                content: "Nome:"

            td:nth-of-type(5):before
                display none

</style>
